import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { logout } from "../../../app/slices/authSlice";
import { useAppDispatch } from "../../../app/stores/store";
import { namespaces } from "../../../i18n/i18n.constants";
import envSettings from "../../../services/system/envSettings";

const HeaderPanel = () => {
  const { t } = useTranslation();
  const tAreaNS = { ns: namespaces.aria };
  const dispatch = useAppDispatch();

  const handleLogOff = useCallback(() => {
    dispatch(logout({ redirectUrl: envSettings.LOG_OFF_EXT }));
  }, [dispatch]);

  return (
    <div className="row bg-primary position-relative">
      <a href="#main-content" className="bg-white p-3 visually-hidden-focusable z-1">
        {t("navigatePanel.headerPanel.mainContent")}
      </a>
      <div className="col"></div>
      <NavLink to={envSettings.TSB_EXT} className="col-auto header-element skatdklogo">
        <span className="visually-hidden">{t("navigatePanel.headerPanel.frontPage")}</span>
      </NavLink>
      <div className="col position-static">
        <div className="row h-100 justify-content-end position-static">
          <button
            className="col-auto header-element bg-skatdk bg-hover bg-focus border-0"
            id="logOff"
            aria-label={t("button.navLogOff", tAreaNS)}
            onClick={handleLogOff}
          >
            <span className="ikon ikon-log-ud"></span>
            <span className="d-md-block d-none ms-3">{t("buttons.logOff")}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeaderPanel;
